import utils from '@/plugins/TravellerUtils'

const sseDisplay = {
  namespaced: true,
  state: {
    sseDisplayList: [],
    sseDisplayListTimestamp: null,
    sseDisplayParameterList: [],
    screenshots: {},
    layouts: [],
    sseDisplayLogs: [],
  },
  mutations: {
    updateDisplayList(state, newList) {
      state.sseDisplayListTimestamp = new Date().getTime()
      state.sseDisplayList = newList
    },
    updateDisplayParameterList(state, newList) {
      state.sseDisplayParameterList = newList
    },
    putScreenshot(state, image) {
      //state.screenshots[image.identifier] = image.base64;
      state.screenshots[image.identifier] = image

      // screenshots-olion yksittäisen jäsenen muuttaminen ei saa aikaan computed propertyjen päivitystä.
      state.screenshots = { ...state.screenshots }
    },
    updateLayouts(state, newList) {
      state.layouts = newList
    },
    updateSseDisplayLogs(state, newList) {
      state.sseDisplayLogs = newList
    },
  },
  actions: {
    getDisplayList(context, expireTime) {
      return new Promise((resolve, reject) => {
        var now = new Date().getTime()
        // if expire time is not given or last update is more than expire time make the real backend request
        // Otherwise just return stored data
        try {
          if (context.state.sseDisplayParameterList.length > 0) {
            if (
              context.state.sseDisplayListTimestamp + expireTime * 1000 >=
              now
            ) {
              resolve(context.state.sseDisplayList)
              return
            }
          }
        } catch (err) {
          /*tyhjää*/
        }

        this._vm.$traveller_http
          .get('/traveller/restui/ssedisplay/getdisplays')
          .then(function (response) {
            if (!utils.checkResponseIsArray(response)) {
              reject('Error in display query')
            }

            var newList = []
            for (const i in response.data) {
              newList.push(response.data[i])
              var status = {}
              if (newList[i].status && newList[i].status.length) {
                for (const j in newList[i].status) {
                  status[newList[i].status[j].name.toLowerCase()] = {
                    value: newList[i].status[j].value,
                    timestamp: newList[i].status[j].timestamp,
                  }
                }
              }
              newList[i].status = status
              var configuration = {}
              if (newList[i].attributes && newList[i].attributes.length) {
                for (const j in newList[i].attributes) {
                  //configuration[newList[i].attributes[j].name] = newList[i].attributes[j].value;
                  configuration[newList[i].attributes[j].name.toLowerCase()] =
                    newList[i].attributes[j].value
                }
              }
              newList[i].configuration = configuration
            }
            context.commit('updateDisplayList', newList)
            resolve(context.state.sseDisplayList)
          })
      })
    },
    saveDisplay(context, formDisplay) {
      var data = {}
      data.deviceId = formDisplay.deviceId
      data.type = 'SSE_DISPLAY'
      data.name = formDisplay.name
      data.location = JSON.parse(JSON.stringify(formDisplay.location))
      data.description = formDisplay.description
      data.attributes = JSON.parse(JSON.stringify(formDisplay.configuration))
      data.status = null
      data.organisaatio = formDisplay.organisaatio
      data.uniqueId = formDisplay.uniqueId
      data.mode = formDisplay.mode
      data.onlineStatus = null

      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/ssedisplay/savedisplay', data)
          .then((response) => {
            if (response.status == 200) {
              context.dispatch('getDisplayList')
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteDisplay(context, id) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/ssedisplay/deletedisplay', {
            params: { id: id },
          })
          .then((response) => {
            if (response.status == 200) {
              context.dispatch('getDisplayList')
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getDisplayParameterList(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/ssedisplay/getvalidparameters')
        .then((response) => {
          context.commit('updateDisplayParameterList', response.data)
        })
    },
    getScreenshot(context, identifier) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/ssedisplay/getscreenshot', {
            params: { identifier: identifier },
          })
          .then((response) => {
            if (response.status == 200) {
              context.commit('putScreenshot', {
                identifier: identifier,
                base64: response.data.base64,
                timestamp: response.data.timestamp,
              })
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    sendCaptureRequest(context, id) {
      context.dispatch('sendAction', { action: 'sendcapturerequests', id })
    },
    sendAction(context, payload) {
      const id = payload.id
      var idList = []
      if (id) {
        if (Array.isArray(id)) {
          idList = id
        } else {
          idList.push(id)
        }
      }
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/ssedisplay/' + payload.action, idList)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getLayouts(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/ssedisplay/getlayouts')
        .then(function (response) {
          context.commit('updateLayouts', response.data)
        })
    },
    setLayout(context, params) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/ssedisplay/setlayout', { params: params })
          .then((response) => {
            if (response.status == 200) {
              context.dispatch('getDisplayList')
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          },
          (error) => {
            reject(error)
          }
      })
    },
    getSseLogs(context, deviceId) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/ssedisplay/getSseLogs', {
            params: { deviceid: deviceId },
          })
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateSseDisplayLogs', response.data)
            }
            resolve(response.data)
          }),
          (error) => {
            reject(error)
          }
      })
    },
  },
}
export default sseDisplay
